import Service from '../../services'

// initial state
const state = {

    allYears: [],
    allCindexTable: []

};


// getters
const getters = {

};


// actions
const actions = {

    onGetAllYears({ commit }) {
        return Service.cindex.getAllYears().then((res) => {
            commit('setAllYears', res);
        })
    },

    onGetAllCindexTable({ commit }) {
        return Service.cindex.getAllCindexTable().then((res) => {
            commit('setAllCindexTable', res);
        })
    }

};


// mutations
const mutations = {

    setAllYears(state, data) {
        state.allYears = data;
    },

    setAllCindexTable(state, data) {
        state.allCindexTable = data;
    }

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
